import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Paper,
  Button,
  Card,
  CardContent,
  CardActions,
  useTheme,
  Grid,
} from '@mui/material';
import {
  School as SchoolIcon,
  ArrowForward as ArrowForwardIcon,
} from '@mui/icons-material';

const SchoolSignup: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [selectedCountry, setSelectedCountry] = useState<string>('');

  const handleCountrySelection = (country: string) => {
    setSelectedCountry(country);
    if (country === 'USA') {
      navigate('/school-signup/usa');
    } else if (country === 'India') {
      navigate('/school-signup/india');
    }
  };

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      py: 4,
      display: 'flex',
      alignItems: 'center'
    }}>
      <Container maxWidth="md">
        <Paper 
          elevation={24} 
          sx={{ 
            p: 6, 
            borderRadius: 3,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
            textAlign: 'center'
          }}
        >
          <Box sx={{ mb: 4 }}>
            <SchoolIcon 
              sx={{ 
                fontSize: 80, 
                color: 'primary.main',
                mb: 2
              }} 
            />
            <Typography 
              variant="h3" 
              component="h1" 
              gutterBottom 
              sx={{ 
                fontWeight: 800,
                background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                mb: 2
              }}
            >
              School Registration
            </Typography>
            
            <Typography 
              variant="h6" 
              color="text.secondary" 
              paragraph
              sx={{ mb: 4 }}
            >
              Register your educational institution on VerTechie and connect with tech talent
            </Typography>

            <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
              Select Your Country
            </Typography>

            <Grid container spacing={3} sx={{ mb: 4 }}>
              <Grid item xs={12} sm={6}>
                <Card 
                  sx={{ 
                    cursor: 'pointer',
                    transition: 'all 0.3s',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: 6
                    }
                  }}
                  onClick={() => handleCountrySelection('USA')}
                >
                  <CardContent sx={{ textAlign: 'center', py: 4 }}>
                    <Typography variant="h4" sx={{ mb: 2 }}>🇺🇸</Typography>
                    <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
                      United States
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Register your US School
                    </Typography>
                  </CardContent>
                  <CardActions sx={{ justifyContent: 'center', pb: 2 }}>
                    <Button
                      variant="contained"
                      endIcon={<ArrowForwardIcon />}
                      sx={{
                        background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                        borderRadius: 2,
                        px: 3
                      }}
                    >
                      Continue
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Card 
                  sx={{ 
                    cursor: 'pointer',
                    transition: 'all 0.3s',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: 6
                    }
                  }}
                  onClick={() => handleCountrySelection('India')}
                >
                  <CardContent sx={{ textAlign: 'center', py: 4 }}>
                    <Typography variant="h4" sx={{ mb: 2 }}>🇮🇳</Typography>
                    <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
                      India
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Register your Indian School
                    </Typography>
                  </CardContent>
                  <CardActions sx={{ justifyContent: 'center', pb: 2 }}>
                    <Button
                      variant="contained"
                      endIcon={<ArrowForwardIcon />}
                      sx={{
                        background: 'linear-gradient(45deg, #FF6B35 30%, #F7931E 90%)',
                        borderRadius: 2,
                        px: 3
                      }}
                    >
                      Continue
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>

            <Button
              variant="outlined"
              onClick={() => navigate('/signup')}
              sx={{
                borderColor: 'primary.main',
                borderRadius: 2,
                px: 3,
                py: 1.5
              }}
            >
              Back to Signup Options
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default SchoolSignup;








